import { ApiRequest } from '../baseService'

const BaseRoute = 'app/monitoring'

// Monitoring data must always be fresh — bypass react-query caching on purpose.
function GetJobsSummary() {
  return ApiRequest.get(`${BaseRoute}/jobs-summary`)
}

function GetFailedJobs(params: { skipCount: number; maxResultCount: number }) {
  return ApiRequest.get(`${BaseRoute}/failed-jobs`, { params })
}

function GetEmailFailureSummary() {
  return ApiRequest.get(`${BaseRoute}/email-failure-summary`)
}

function GetFailedEmails(params: {
  skipCount: number
  maxResultCount: number
  days?: number
}) {
  return ApiRequest.get(`${BaseRoute}/failed-emails`, { params })
}

function GetActiveUsersSummary() {
  return ApiRequest.get(`${BaseRoute}/active-users-summary`)
}

function GetHealthStatus() {
  return ApiRequest.get(`${BaseRoute}/health-status`)
}

function GetEmlDataIssuesSummary() {
  return ApiRequest.get(`${BaseRoute}/eml-data-issues-summary`)
}

const API = {
  GetJobsSummary,
  GetFailedJobs,
  GetEmailFailureSummary,
  GetFailedEmails,
  GetActiveUsersSummary,
  GetHealthStatus,
  GetEmlDataIssuesSummary,
}

export default API
